import { getRequestAuthPayload } from '@helpers/getRequestAuth';
import type { FeatureAccessResponse } from '@responses/feature-access';
import axios from 'axios';

export const fetchFeatureAccess = async (): Promise<FeatureAccessResponse> => {
  const networkPayload = await getRequestAuthPayload({
    method: 'get',
    url: '/feature_access',
  });
  const { data } = await axios(networkPayload);
  return data;
};
